import * as React from 'react';

export const votedIcon = <i className="material-icons">check_box</i>;
export const openIcon = <i className="material-icons">check_box_outline_blank</i>;
export const closedIcon = <i className="material-icons">lock_outline</i>;
export const seatIcon = <i className="material-icons">event_seat</i>;
export const helpIcon = <i className="material-icons">help_outline</i>;
export const warningIcon = <i className="material-icons">warning</i>;
export const downloadIcon = <i className="material-icons">file_download</i>;
export const saveIcon = <i className="material-icons">save</i>;
export const editIcon = <i className="material-icons">border_color</i>;
export const cancelIcon = <i className="material-icons">cancel</i>;
export const menuIcon = <i className="material-icons">more_horizon</i>;
export const peopleIcon = <i className="material-icons">people_outline</i>;
export const addPeopleIcon = <i className="material-icons">group_add</i>;
export const checkCircleIcon = <i className="material-icons">check_circle</i>;
